module.exports = __webpack_public_path__ + "static/nizo-589042d2d54a9d0d1108213ec8d5aa58.png";